import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  Self,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NgControl,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

type Value = string | number | Record<string, any>;
@Component({
  selector: 'app-radio-group',
  templateUrl: './input-radio-group.component.html',
  styleUrls: ['./input-radio-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputRadioGroupComponent implements ControlValueAccessor, OnInit {
  @Output() clickInput = new EventEmitter<MouseEvent>();
  @Output() ngModelChange = new EventEmitter<string>();
  @Input() label!: string;
  @Input() optionLabel: string = 'name';
  @Input() optionValue: string = 'value';
  @Input() options: Value[] = [];

  public disabled = false;
  public required: boolean = false;
  public value!: string | number;
  public touched = false;
  public matcher: ErrorStateMatcher = {
    isErrorState: () => {
      return this.touched && !!this.ngControl.errors;
    },
  };

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  onChange = (_value: string | number) => {
    //esta função é utilizada internamente pelo form
  };

  onTouched = () => {
    //esta função é utilizada internamente pelo form
  };

  _optionLabel(option: Value): string | number {
    if (typeof option !== 'object') {
      return option;
    }
    return option?.[this.optionLabel] || '';
  }

  _optionValue(optionValue: Value) {
    if (typeof optionValue !== 'object') {
      return optionValue;
    }
    return optionValue?.[this.optionValue];
  }

  _isOptionDisabled(optionValue: Value) {
    if (typeof optionValue !== 'object') {
      return false;
    }
    return optionValue?.['disabled'] || false;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string | number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  hasRequiredValidator(control: AbstractControl | null): boolean {
    if (control?.validator) {
      const validator = control.validator({} as AbstractControl);
      if (validator && validator['required']) {
        return true;
      }
    }
    return false;
  }

  ngOnInit(): void {
    if (this.ngControl) {
      this.required = this.hasRequiredValidator(this.ngControl.control);
    }
  }
}
